const ForeignLaborQuery = (id) => {
    return `
    query {
      deleteRecruiter(id: "${id}")
    } 
    `
}

export default ForeignLaborQuery